import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function CreateMemoIconSvg() {
  return (
    <svg
      width="27"
      height="19"
      viewBox="0 0 27 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="17" r="2" fill="white" />
      <rect x="7" width="20" height="12" rx="2" fill="white" />
      <line x1="1.6" y1="16.7" x2="7.6" y2="8.7" stroke="white" />
      <circle cx="12" cy="6" r="1" fill="#D9D9D9" />
      <circle cx="17" cy="6" r="1" fill="#D9D9D9" />
      <circle cx="22" cy="6" r="1" fill="#D9D9D9" />
    </svg>
  )
}

function SelectedCreateMemoIconSvg() {
  return (
    <svg
      width="27"
      height="19"
      viewBox="0 0 27 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="17" r="2" fill="#609DF9" />
      <rect x="7" width="20" height="12" rx="2" fill="#609DF9" />
      <line x1="1.6" y1="16.7" x2="7.6" y2="8.7" stroke="#609DF9" />
      <circle cx="12" cy="6" r="1" fill="#D9D9D9" />
      <circle cx="17" cy="6" r="1" fill="#D9D9D9" />
      <circle cx="22" cy="6" r="1" fill="#D9D9D9" />
    </svg>
  )
}

export default function CreateMemoIcon(
  props: Partial<CustomIconComponentProps> & { selected?: boolean }
) {
  const { selected, ...rest } = props

  if (selected) return <Icon component={SelectedCreateMemoIconSvg} {...rest} />

  return <Icon component={CreateMemoIconSvg} {...rest} />
}

CreateMemoIcon.defaultProps = {
  selected: undefined
}
